import React, { useRef } from 'react';
import emailjs from 'emailjs-com';
import './contact.css'
import {MdOutlineEmail, MdWhatsapp, MdOutlinePhoneAndroid} from 'react-icons/md'

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm('service_on8lc6x', 'template_29ent7m', form.current, 'S3OUdRey29StojInL')

        e.target.reset()
    };
    return (
        <section id="contact">
            <h5>Get In Touch</h5>
            <h2>Contact Me</h2>
            <div className="container contact__container">
                <div className="contact__options">
                    <article className="contact__option">
                        <MdOutlineEmail className="contact__option-icon"/>
                        <h4>Email</h4>
                        <a rel="noreferrer" href="mailto:anastasiiakubrak20@gmail.com">Send a message</a>
                    </article>
                    <article className="contact__option">
                        <MdOutlinePhoneAndroid className="contact__option-icon"/>
                        <h4>Phone</h4>
                        <a rel="noreferrer" href="tel:+31638705434">Call me</a>
                    </article>
                    <article className="contact__option">
                        <MdWhatsapp className="contact__option-icon"/>
                        <h4>WhatsApp</h4>
                        <a rel="noreferrer" href="https://api.whatsapp.com/send?phone=380682855685" target="_blank">Send a message</a>
                    </article>
                </div>
                {/* <form  ref={form} onSubmit={sendEmail}>
                   <input type="text" name="name" placeholder="Your Full Name" required/>
                <input type="email" name="email" placeholder="Your Email" required/>
                   <textarea name="message" rows="7" placeholder="Your Message" required></textarea>
                <button type="submit" className="btn btn-primary">Send Message</button>
                </form> */}
            </div>
        </section>
    )
}
export default Contact
